import { formatIrkutskDateTime } from "../../lib/time";
import { bonusHistoryKindLabel } from "./bonusHistoryLabels";

export function BonusHistoryList({ history, historyLoading }) {
  return (
    <div className="bonusHistory">
      <h3>История операций</h3>
      {historyLoading ? <p className="muted">Загрузка...</p> : null}
      {!historyLoading && history.length === 0 ? <p className="muted">Пока нет операций.</p> : null}
      {!historyLoading && history.length > 0 ? (
        <ul className="bonusHistory__list">
          {history.map((row) => {
            const isDebit = row.kind === "debit_redeem";
            const isAdminAdj = row.kind === "admin_adj";
            const adminAdjNegative = isAdminAdj && row.amount < 0;
            const isChannelForfeit = row.kind === "ch_forfeit";
            const kindLabel = bonusHistoryKindLabel(row.kind);
            const amountAbs = Math.abs(row.amount);
            const showDebitStyle = isDebit || adminAdjNegative || isChannelForfeit;
            return (
              <li key={row.id}>
                <span
                  className={
                    showDebitStyle
                      ? "bonusHistory__amount bonusHistory__amount--debit"
                      : "bonusHistory__amount"
                  }
                >
                  {isDebit || adminAdjNegative ? "−" : "+"}
                  {amountAbs}
                </span>
                <span className="bonusHistory__meta">
                  {kindLabel}
                  {row.balance_after != null ? ` · баланс ${row.balance_after}` : ""}
                  {row.created_at ? ` · ${formatIrkutskDateTime(row.created_at)}` : ""}
                </span>
              </li>
            );
          })}
        </ul>
      ) : null}
    </div>
  );
}
